/**
 * Which file a release track plays (Gordon 2026-11-03: "track 2 is playing
 * track 3 … playing the release playlist it is off"). A track on a release is
 * a recording, and the recording's own work doc holds its file. The copy on the
 * release's track list can drift (on "Extreme Paranoia in Stocktown" tracks
 * 2–13 each pointed at the NEXT track's file), so the work's file wins. The
 * list's copy is used only when the work has none, or only has a file browsers
 * can't play (AIFF) while the list has one they can.
 */

const UNPLAYABLE = /\.(aif|aiff)(\?|#|$)/i;

export function workAudioUrl(work: any): string {
  return String(work?.mp3Url || work?.audioUrl || work?.url || '');
}

export function trackAudio(listUrl: string | undefined, workUrl: string | undefined): string {
  const list = String(listUrl || '');
  const own = String(workUrl || '');
  if (!own) return list;
  if (UNPLAYABLE.test(own) && list && !UNPLAYABLE.test(list)) return list;
  return own;
}
